import loadable from '@loadable/component';
import { useParams } from 'react-router-dom';
import { tw } from '@careinfo/tailwind';
import useGetHook from '../../customHooks/useGetHook';
import APIS from '../../constant/EndPoint';
import Spinner from '../../components/Reusable/Spinner';
import usePostHook from '../../customHooks/usePostHook';
const LocationListComponent = loadable(
  () => import('../../components/Location/LocationList')
);

const LocationList = () => {
  const { slug } = useParams<{ slug: string }>();
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: [`location-${slug}`],
  });
  const handleAsync = async () => {
    const url = `${APIS.DELIVERY_PARTNER}${slug}/sync-location/`;
    const formData = {};
    try {
      await mutateAsync({ url, formData, setError: () => { } });
    } catch (err) {
      console.error(err);
    }
  };

  const { data, isLoading } = useGetHook({
    queryKey: [`location-${slug}`],
    url: `${APIS.DELIVERY_PARTNER}${slug}/location/`,
    params: {},
  });

  return isLoading ? (
    <Spinner />
  ) : (
    <div>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <span className={tw`text-[#5E5757] font-bold text-xl`}>Location</span>
      </div>
      <LocationListComponent
        slug={slug}
        receiverLocation={data?.results}
        handleAsync={handleAsync}
        isLoading={isPostLoading}
      />
    </div>
  );
};

export default LocationList;
